export const css = (...args) =>
    args.filter(s => s !== '' && s != false).join(' ');